import Vue from 'vue';
import VModal from 'vue-js-modal';
import './static.css';
import ui from './src/ui.vue';
Vue.use(VModal);
new Vue({ render: ce => ce(ui) }).$mount('#app');